// Provide configuration that is supplied at build time.
export var getClientVersion = function () { return "1.10.2"; };
//# sourceMappingURL=buildConfig.js.map